      
/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-28 09:16:52
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-06-07 16:00:25
 * @FilePath: \vue-hepha-order\src\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import {createRouter,createWebHashHistory} from 'vue-router';
import { defineAsyncComponent } from 'vue';
import Layout from '@/layout/Index.vue';
import Login from '@/views/login/Login.vue';
import FeishuLogin from '@/views/login/FeishuLogin.vue';
import Register from '@/views/login/Register.vue';
import ForgetPwd from '@/views/login/ForgetPwd.vue';
import Dashboard from '@/views/dashboard/Index.vue';
import OrderList from '@/views/order/OrderList.vue';
import ProductList from '@/views/product/ProductList.vue';
// import ProductQuery from '@/views/product/ProductQuery.vue';
import BomQuery from '@/views/product/BomQuery.vue';
import CustomerList from '@/views/customer/CustomerList.vue';
import ErrorLog from '@/views/log/ErrorLog.vue';
import OrderRiskVerificationLog from '@/views/log/OrderRiskVerificationLog.vue';
import SOSyncConf from '@/views/base/SOSyncConf.vue'; 
import OrderSource from '@/views/base/OrderSource.vue';
import EmailReceive from '@/views/base/EmailReceive.vue';
import CountryCodeConfig from '@/views/base/CountryCodeConfig.vue';
import Role from '@/views/setting/Role.vue';
import User from '@/views/setting/User.vue';
import AddEmail from '@/views/setting/AddEmail.vue';
import DealerForm from '@/views/share/DealerForm.vue'
import StockOutList from '@/views/stock/StockOutList.vue';
import DealerList from '@/views/dealer/DealerList.vue';
import FinancialReceipts from '@/views/financial/FinancialReceipts.vue';
import ReturnOrderList from '@/views/returnOrder/ReturnOrderList.vue';
import DealerGoal from '@/views/saleGoal/DealerGoal.vue';
import SaleFrameGoal from '@/views/saleGoal/SaleFrameGoal.vue';
import InvoiceList from '@/views/invoice/InvoiceList.vue';
import PriceList from '@/views/financial/PriceList.vue';
import PreOrderList from '@/views/dealerPreOrder/PreOrderList.vue';
import B2BShopOrderList from '@/views/dealerPreOrder/B2BShopOrderList.vue';
import DealerOpenOrderList from '@/views/dealerOpenOrder/DealerOpenOrderList.vue';
import OrderApprovalList from '@/views/approval/OrderApprovalList.vue';
import ProductPlanList from '@/views/product/ProductPlanList.vue';
import AvailabilityReport from '@/views/product/AvailabilityReport.vue';
import ProductQuery from '@/views/product/ProductQuery.vue';
import PrepaidOrderList from '@/views/prepaidOrder/PrepaidOrderList.vue';
import TaxConfig from '@/views/financial/TaxConfig.vue';
import SignatureList from '@/views/financial/SignatureList.vue';
import DealerLevelConfig from '@/views/financial/DealerLevelConfig.vue';
import SaleDealerConfig from '@/views/base/SaleDealerConfig.vue';
import AreaSaleManagerConfig from '@/views/base/AreaSaleManagerConfig.vue';
import DeliveryDateRangeConfig from '@/views/base/DeliveryDateRangeConfig.vue';
import Cash from '@/views/financial/Cash.vue';
import Accounts from '@/views/financial/Accounts.vue';
import KpiDailyReportList from '@/views/kpiDailyReport/List.vue';
import InventoryLockList from '@/views/inventoryLock/InventoryLockList.vue';
import PreSaleOrder from '@/views/preOrder/PreSaleOrderList.vue';

// import MenuManage from '@/views/setting/MenuManage.vue';

import WarningList from '@/views/warning/WarningList.vue';

import ErrorPage from '@/views/login/404.vue';



const routes = [
    {
        path:'/',
        name:'Index',
        component: Layout,
        redirect:'/OrderList/OrderList',
        children:[
            // {
            //     path:'/Dashboard',
            //     name:'Dashboard',
            //     // component:Dashboard,
            //     meta:{ 
            //         title:"数据看板",
            //         icon:"IconDashboard",
            //         locale:"menu.dashboard",
            //         requiresAuth:true
            //     },
            //     children:[
            //         {
            //             path:'/Dashboard/Dashboard',
            //             name:'DashboardMenu',
            //             component:Dashboard,
            //             meta:{ 
            //                 title:"数据看板",
            //                 icon:"IconDashboard",
            //                 locale:"menu.dashboard",
            //                 requiresAuth:true
            //             },
            //         },
            //         {
            //             path:'/Dashboard/KpiDailyReport',
            //             name:'KpiDailyReport',
            //             component:KpiDailyReportList,
            //             meta:{ 
            //                 title:"KPI日报表",
            //                 icon:"IconBook",
            //                 locale:"menu.kpiDailyReport",
            //                 requiresAuth:true 
            //             },
            //         },
            //     ]
            // },
            {
                path:'/OrderList',
                name:'OrderList',
                // path:'/Order',
                // name:'Order',
                // component:OrderList,
                meta:{ 
                    title:"订单管理",
                    icon:"IconApps",
                    locale:"menu.orderList",
                    requiresAuth:true
                },
                children:[
                    {
                        path:'/OrderList/OrderList',
                        name:'OrderOrderList',
                        component: OrderList,
                        meta:{ 
                            title:"订单列表",
                            icon:"IconList",
                            locale:"menu.orderSubList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/OrderList/InvoiceList',
                        name:'InvoiceList',
                        component:InvoiceList,
                        meta:{ 
                            title:"发票管理",
                            icon:"IconFile",
                            locale:"menu.invoiceList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/OrderList/DealerOpenOrderList',
                        name:'DealerOpenOrderList',
                        component:DealerOpenOrderList,
                        meta:{ 
                            title:"经销商未完结订单",
                            icon:"IconOrderedList",
                            locale:"menu.dealerOpenOrder",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/OrderList/B2BShopOrderList',
                        name:'B2BShopOrderList',
                        component:B2BShopOrderList,
                        meta:{ 
                            title:"B2B Shop订单",
                            icon:"IconList",
                            locale:"menu.B2BShopOrderList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/OrderList/PreSaleOrder',
                        name:'PreSaleOrder',
                        component:PreSaleOrder,
                        meta:{ 
                            title:"预售订单",
                            icon:"IconTranslate",
                            locale:"menu.preSaleOrder",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/OrderList/PrepaidOrder',
                        name:'PrepaidOrder',
                        component:PrepaidOrderList,
                        meta:{ 
                            title:"预付款订单管理",
                            icon:"IconCommon",
                            locale:"menu.prepaidOrderList",
                            requiresAuth:true 
                        },
                    },
                    // {
                    //     path:'/OrderList/DataStatistics',
                    //     name:'DataStatistics',
                    //     component: DataStatistics,
                    //     meta:{ 
                    //         title:"数据统计",
                    //         icon:"IconBarChart",
                    //         locale:"menu.dataStatistics",
                    //         requiresAuth:true 
                    //     },
                    // }
                ]
            },
            {
                path:'/Deliver',
                name:'Deliver',
                meta:{ 
                    title:"整车交付管理",
                    icon:"IconLayers",
                    locale:"menu.eBikeAvailability",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Deliver/AvailabilityReport',
                        name:'AvailabilityReport',
                        component: AvailabilityReport,
                        meta:{ 
                            title:"交付报表",
                            icon:"IconSearch",
                            locale:"menu.availabilityReport",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/InventoryLockList',
                        name:'InventoryLockList',
                        component:InventoryLockList,
                        meta:{ 
                            title:"库存锁定",
                            icon:"IconLock",
                            locale:"menu.inventoryLock",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Product/BomQuery',
                        name:'BomQuery',
                        component: BomQuery,
                        meta:{ 
                            title:"整车部件查询",
                            icon:"IconSearch",
                            locale:"menu.bomQuery",
                            requiresAuth:true 
                        },
                    },
                    
                ]
            },

            {
                path:'/Outbounds',
                name:'Outbounds',
                meta:{ 
                    title:"出库",
                    icon:"IconStorage",
                    locale:"menu.outbounds",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Outbounds/StockOutList',
                        name:'StockOutList',
                        component:StockOutList,
                        meta:{ 
                            title:"库存管理",
                            icon:"IconStorage",
                            locale:"menu.stockOutList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Outbounds/WarningList',
                        name:'WarningList',
                        component:WarningList,
                        meta:{ 
                            title:"预警管理",
                            icon:"IconBulb",
                            locale:"menu.warningList",
                            requiresAuth:true 
                        },
                    },
                ]
            },

            {
                path:'/Customers',
                name:'Customers',
                meta:{ 
                    title:"客户",
                    icon:"IconUser",
                    locale:"menu.customers",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Customers/CustomerList',
                        name:'CustomerList',
                        component:CustomerList,
                        meta:{ 
                            title:"客户管理",
                            icon:"IconUser",
                            locale:"menu.customerList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Customers/DealerList',
                        name:'DealerList',
                        component:DealerList,
                        meta:{ 
                            title:"经销商管理",
                            icon:"IconUserGroup",
                            locale:"menu.dealerList",
                            requiresAuth:true 
                        },
                    },
                ]
            },
            {
                path:'/Product',
                name:'Product',
                meta:{ 
                    title:"产品管理",
                    icon:"IconCommon",
                    locale:"menu.productList",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Product/ProductList',
                        name:'ProductList',
                        component: ProductList,
                        meta:{ 
                            title:"产品管理",
                            icon:"IconCommon",
                            locale:"menu.productList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Product/ProductPlanList',
                        name:'ProductPlanList',
                        component: ProductPlanList,
                        meta:{ 
                            title:"交付维护",
                            icon:"IconEdit",
                            locale:"menu.availabilityEdit",
                            requiresAuth:true 
                        },
                    },
                ]
            },

            {
                path:'/Config',
                name:'Config',
                // component:SOSyncConf,
                meta:{ 
                    title:"基础配置",
                    icon:"IconRelation",
                    locale:"menu.config",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Config/CountryCodeConfig',
                        name:'CountryCodeConfig',
                        component: CountryCodeConfig,
                        meta:{ 
                            title:"国家代码配置",
                            icon:"IconPublic",
                            locale:"menu.countryCodeConfig",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Config/AreaSaleManagerConfig',
                        name:'AreaSaleManagerConfig',
                        component: AreaSaleManagerConfig,
                        meta:{ 
                            title:"区域销售经理配置",
                            icon:"IconUserAdd",
                            locale:"menu.areaSaleManagerConfig",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Config/EmailReceive',
                        name:'EmailReceive',
                        component: EmailReceive,
                        meta:{ 
                            title:"邮件接收配置",
                            icon:"IconEmail",
                            locale:"menu.emailReceive",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Config/DeliveryDateRangeConfig',
                        name:'DeliveryDateRangeConfig',
                        component: DeliveryDateRangeConfig,
                        meta:{ 
                            title:"经销商发货日期区间配置",
                            icon:"IconSun",
                            locale:"menu.deliveryDateRangeConfig",
                            requiresAuth:true 
                        },
                    },
                ]
            },

            {
                path:'/Financial',
                name:'Financial',
                meta:{ 
                    title:"财务管理",
                    icon:"IconSafe",
                    locale:"menu.financial",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Financial/DealerGoal',
                        name:'DealerGoal',
                        component: DealerGoal,
                        meta:{ 
                            title:"经销商目标",
                            icon:"IconUserAdd",
                            locale:"menu.dealerGoal",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Financial/SaleFrameGoal',
                        name:'SaleFrameGoal',
                        component: SaleFrameGoal,
                        meta:{ 
                            title:"销售车架目标",
                            icon:"IconStamp",
                            locale:"menu.saleFrameGoal",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Financial/FinancialReceipts',
                        name:'FinancialReceipts',
                        component:FinancialReceipts,
                        meta:{ 
                            title:"财务收账",
                            icon:"IconSafe",
                            locale:"menu.financialReceipts",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Financial/Cash',
                        name:'Cash',
                        component: Cash,
                        meta:{ 
                            title:"现金流",
                            icon:"IconCopyright",
                            locale:"menu.cash",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Financial/Accounts',
                        name:'Accounts',
                        component: Accounts,
                        meta:{ 
                            title:"应付",
                            icon:"IconTag",
                            locale:"menu.accounts",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Financial/OrderSource',
                        name:'OrderSource',
                        component: OrderSource,
                        meta:{ 
                            title:"同步订单来源",
                            icon:"IconSun",
                            locale:"menu.orderSource",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Financial/PriceList',
                        name:'PriceList',
                        component: PriceList,
                        meta:{ 
                            title:"同步ERP价目表",
                            icon:"IconLoop",
                            locale:"menu.priceList",
                            requiresAuth:true
                        },
                    },
                    {
                        path:'/Financial/TaxConfig',
                        name:'TaxConfig',
                        component: TaxConfig,
                        meta:{ 
                            title:"税率配置",
                            icon:"IconSunFill",
                            locale:"menu.taxConfig",
                            requiresAuth:true
                        },
                    },
                    {
                        path:'/Financial/SignatureList',
                        name:'SignatureList',
                        component: SignatureList,
                        meta:{ 
                            title:"发货签收",
                            icon:"IconSubscribed",
                            locale:"menu.signatureList",
                            requiresAuth:true
                        },
                    },
                ]
            },

            {
                path:'/Dashboard',
                name:'Dashboard',
                // component:Dashboard,
                meta:{ 
                    title:"数据看板",
                    icon:"IconDashboard",
                    locale:"menu.dashboard",
                    requiresAuth:true
                },
                children:[
                    {
                        path:'/Dashboard/Dashboard',
                        name:'DashboardMenu',
                        component:Dashboard,
                        meta:{ 
                            title:"数据看板",
                            icon:"IconDashboard",
                            locale:"menu.dashboard",
                            requiresAuth:true
                        },
                    },
                    {
                        path:'/Dashboard/KpiDailyReport',
                        name:'KpiDailyReport',
                        component:KpiDailyReportList,
                        meta:{ 
                            title:"KPI日报表",
                            icon:"IconBook",
                            locale:"menu.kpiDailyReport",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Dashboard/ProductQuery',
                        name:'ProductQuery',
                        component:ProductQuery,
                        meta:{ 
                            title:"整车库存",
                            icon:"IconSearch",
                            locale:"menu.productQuery", 
                            requiresAuth:true 
                        },
                    },
                ]
            },
            {
                path:'/Log',
                name:'Log',
                // component:ErrorLog,
                meta:{ 
                    title:"日志",
                    icon:"IconBug",
                    locale:"menu.log",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/Log/ErrorLog',
                        name:'ErrorLog',
                        component: ErrorLog,
                        meta:{ 
                            title:"报错日志",
                            icon:"IconBug",
                            locale:"menu.errorLog",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Log/OrderRiskVerificationLog',
                        name:'OrderRiskVerificationLog',
                        component: OrderRiskVerificationLog,
                        meta:{ 
                            title:"订单风险验证日志",
                            icon:"IconEmail",
                            locale:"menu.orderRiskVerificationLog",
                            requiresAuth:true 
                        },
                    },
                ]
            },

            {
                path:'/History',
                name:'History',
                // component:ErrorLog,
                meta:{ 
                    title:"历史",
                    icon:"IconUndo",
                    locale:"menu.history",
                    requiresAuth:true 
                },
                children:[
                    {
                        path:'/History/ReturnOrder',
                        name:'ReturnOrder',
                        component:ReturnOrderList,
                        meta:{ 
                            title:"退货杂单管理",
                            icon:"IconUndo",
                            locale:"menu.returnOrder",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/History/OrderApprovalList',
                        name:'OrderApprovalList',
                        component:OrderApprovalList,
                        meta:{ 
                            title:"经销商业务订单审批列表",
                            icon:"IconStamp",
                            locale:"menu.orderApprovalList",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/History/DealerBusinessOrder',
                        name:'DealerBusinessOrder',
                        component:PreOrderList,
                        meta:{ 
                            title:"经销商业务订单管理",
                            icon:"IconSelectAll",
                            locale:"menu.preOrderList",
                            requiresAuth:true 
                        },
                    },
                ]
            },

            // {
            //     path:'/PrepaidOrder',
            //     name:'PrepaidOrder',
            //     component:PrepaidOrderList,
            //     meta:{ 
            //         title:"预付款订单管理",
            //         icon:"IconCommon",
            //         locale:"menu.prepaidOrderList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/StockOutList',
            //     name:'StockOutList',
            //     component:StockOutList,
            //     meta:{ 
            //         title:"库存管理",
            //         icon:"IconStorage",
            //         locale:"menu.stockOutList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/InventoryLockList',
            //     name:'InventoryLockList',
            //     component:InventoryLockList,
            //     meta:{ 
            //         title:"库存锁定",
            //         icon:"IconLock",
            //         locale:"menu.inventoryLock",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/WarningList',
            //     name:'WarningList',
            //     component:WarningList,
            //     meta:{ 
            //         title:"预警管理",
            //         icon:"IconBulb",
            //         locale:"menu.warningList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/OrderApprovalList',
            //     name:'OrderApprovalList',
            //     component:OrderApprovalList,
            //     meta:{ 
            //         title:"经销商业务订单审批列表",
            //         icon:"IconStamp",
            //         locale:"menu.orderApprovalList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/DealerBusinessOrder',
            //     name:'DealerBusinessOrder',
            //     component:PreOrderList,
            //     meta:{ 
            //         title:"经销商业务订单管理",
            //         icon:"IconSelectAll",
            //         locale:"menu.preOrderList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/B2BShopOrderList',
            //     name:'B2BShopOrderList',
            //     component:B2BShopOrderList,
            //     meta:{ 
            //         title:"B2B Shop订单管理",
            //         icon:"IconList",
            //         locale:"menu.B2BShopOrderList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/DealerOpenOrderList',
            //     name:'DealerOpenOrderList',
            //     component:DealerOpenOrderList,
            //     meta:{ 
            //         title:"经销商延期订单",
            //         icon:"IconOrderedList",
            //         locale:"menu.dealerOpenOrder",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/ProductPlanList',
            //     name:'ProductPlanList',
            //     component:ProductPlanList,
            //     meta:{ 
            //         title:"可用性计划列表",
            //         icon:"IconLayers",
            //         locale:"menu.productPlanList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/ReturnOrder',
            //     name:'ReturnOrder',
            //     component:ReturnOrderList,
            //     meta:{ 
            //         title:"退货杂单管理",
            //         icon:"IconUndo",
            //         locale:"menu.returnOrder",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/InvoiceList',
            //     name:'InvoiceList',
            //     component:InvoiceList,
            //     meta:{ 
            //         title:"发票管理",
            //         icon:"IconFile",
            //         locale:"menu.invoiceList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/Product',
            //     name:'Product',
            //     meta:{ 
            //         title:"产品管理",
            //         icon:"IconCommon",
            //         locale:"menu.productList",
            //         requiresAuth:true 
            //     },
            //     children:[
            //         {
            //             path:'/Product/ProductList',
            //             name:'ProductList',
            //             component: ProductList,
            //             meta:{ 
            //                 title:"产品管理",
            //                 icon:"IconCommon",
            //                 locale:"menu.productList",
            //                 requiresAuth:true 
            //             },
            //         },
            //         // {
            //         //     path:'/Product/BomQuery',
            //         //     name:'BomQuery',
            //         //     component: BomQuery,
            //         //     meta:{ 
            //         //         title:"整车部件查询",
            //         //         icon:"IconSearch",
            //         //         locale:"menu.bomQuery",
            //         //         requiresAuth:true 
            //         //     },
            //         // },
            //     ]
            // },
            // {
            //     path:'/Deliver',
            //     name:'Deliver',
            //     meta:{ 
            //         title:"整车交付管理",
            //         icon:"IconLayers",
            //         locale:"menu.eBikeAvailability",
            //         requiresAuth:true 
            //     },
            //     children:[
            //         {
            //             path:'/Deliver/ProductPlanList',
            //             name:'ProductPlanList',
            //             component: ProductPlanList,
            //             meta:{ 
            //                 title:"交付维护",
            //                 icon:"IconEdit",
            //                 locale:"menu.availabilityEdit",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Deliver/AvailabilityReport',
            //             name:'AvailabilityReport',
            //             component: AvailabilityReport,
            //             meta:{ 
            //                 title:"交付报表",
            //                 icon:"IconSearch",
            //                 locale:"menu.availabilityReport",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Deliver/ProductQuery',
            //             name:'ProductQuery',
            //             component:ProductQuery,
            //             meta:{ 
            //                 title:"整车库存",
            //                 icon:"IconSearch",
            //                 locale:"menu.productQuery", 
            //                 requiresAuth:true 
            //             },
            //         },
            //     ]
            // },
            // {
            //     path:'/ProductQuery',
            //     name:'ProductQuery',
            //     component:ProductQuery,
            //     meta:{ 
            //         title:"产品查询",
            //         icon:"IconSearch",
            //         locale:"menu.productQuery", 
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/CustomerList',
            //     name:'CustomerList',
            //     component:CustomerList,
            //     meta:{ 
            //         title:"客户管理",
            //         icon:"IconUser",
            //         locale:"menu.customerList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/DealerList',
            //     name:'DealerList',
            //     component:DealerList,
            //     meta:{ 
            //         title:"经销商管理",
            //         icon:"IconUserGroup",
            //         locale:"menu.dealerList",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/KpiDailyReport',
            //     name:'KpiDailyReport',
            //     component:KpiDailyReportList,
            //     meta:{ 
            //         title:"KPI日报表",
            //         icon:"IconBook",
            //         locale:"menu.kpiDailyReport",
            //         requiresAuth:true 
            //     },
            // },
            // {
            //     path:'/SaleGoal',
            //     name:'SaleGoal',
            //     // component:SOSyncConf,
            //     meta:{ 
            //         title:"销售目标",
            //         icon:"IconTrophy",
            //         locale:"menu.saleGoal",
            //         requiresAuth:true 
            //     },
            //     children:[
            //         {
            //             path:'/SaleGoal/DealerGoal',
            //             name:'DealerGoal',
            //             component: DealerGoal,
            //             meta:{ 
            //                 title:"经销商目标",
            //                 icon:"IconUserAdd",
            //                 locale:"menu.dealerGoal",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/SaleGoal/SaleFrameGoal',
            //             name:'SaleFrameGoal',
            //             component: SaleFrameGoal,
            //             meta:{ 
            //                 title:"销售车架目标",
            //                 icon:"IconStamp",
            //                 locale:"menu.saleFrameGoal",
            //                 requiresAuth:true 
            //             },
            //         },
            //     ]
            // },
            // {
            //     path:'/Financial',
            //     name:'Financial',
            //     meta:{ 
            //         title:"财务管理",
            //         icon:"IconSafe",
            //         locale:"menu.financial",
            //         requiresAuth:true 
            //     },
            //     children:[
            //         {
            //             path:'/Financial/FinancialReceipts',
            //             name:'FinancialReceipts',
            //             component:FinancialReceipts,
            //             meta:{ 
            //                 title:"财务收账",
            //                 icon:"IconSafe",
            //                 locale:"menu.financialReceipts",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Financial/Cash',
            //             name:'Cash',
            //             component: Cash,
            //             meta:{ 
            //                 title:"现金流",
            //                 icon:"IconCopyright",
            //                 locale:"menu.cash",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Financial/Accounts',
            //             name:'Accounts',
            //             component: Accounts,
            //             meta:{ 
            //                 title:"应付",
            //                 icon:"IconTag",
            //                 locale:"menu.accounts",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Financial/OrderSource',
            //             name:'OrderSource',
            //             component: OrderSource,
            //             meta:{ 
            //                 title:"同步订单来源",
            //                 icon:"IconSun",
            //                 locale:"menu.orderSource",
            //                 requiresAuth:true 
            //             },
            //         },
            //         // {
            //         //     path:'/Financial/EmailReceive',
            //         //     name:'EmailReceive',
            //         //     component: EmailReceive,
            //         //     meta:{ 
            //         //         title:"邮件接收配置",
            //         //         icon:"IconEmail",
            //         //         locale:"menu.emailReceive",
            //         //         requiresAuth:true 
            //         //     },
            //         // },
            //         {
            //             path:'/Financial/PriceList',
            //             name:'PriceList',
            //             component: PriceList,
            //             meta:{ 
            //                 title:"同步ERP价目表",
            //                 icon:"IconLoop",
            //                 locale:"menu.priceList",
            //                 requiresAuth:true
            //             },
            //         },
            //         {
            //             path:'/Financial/TaxConfig',
            //             name:'TaxConfig',
            //             component: TaxConfig,
            //             meta:{ 
            //                 title:"税率配置",
            //                 icon:"IconSunFill",
            //                 locale:"menu.taxConfig",
            //                 requiresAuth:true
            //             },
            //         },
            //         {
            //             path:'/Financial/SignatureList',
            //             name:'SignatureList',
            //             component: SignatureList,
            //             meta:{ 
            //                 title:"发货签收",
            //                 icon:"IconSubscribed",
            //                 locale:"menu.signatureList",
            //                 requiresAuth:true
            //             },
            //         },
            //         // {
            //         //     path:'/Financial/DealerLevelConfig',
            //         //     name:'DealerLevelConfig',
            //         //     component: DealerLevelConfig,
            //         //     meta:{ 
            //         //         title:"经销商等级配置",
            //         //         icon:"IconPushpin",
            //         //         locale:"menu.dealerLevelConfig",
            //         //         requiresAuth:true
            //         //     },
            //         // },
            //     ]
            // },
            // {
            //     path:'/Log',
            //     name:'Log',
            //     // component:ErrorLog,
            //     meta:{ 
            //         title:"日志",
            //         icon:"IconBug",
            //         locale:"menu.log",
            //         requiresAuth:true 
            //     },
            //     children:[
            //         {
            //             path:'/Log/ErrorLog',
            //             name:'ErrorLog',
            //             component: ErrorLog,
            //             meta:{ 
            //                 title:"报错日志",
            //                 icon:"IconBug",
            //                 locale:"menu.errorLog",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Log/OrderRiskVerificationLog',
            //             name:'OrderRiskVerificationLog',
            //             component: OrderRiskVerificationLog,
            //             meta:{ 
            //                 title:"订单风险验证日志",
            //                 icon:"IconEmail",
            //                 locale:"menu.orderRiskVerificationLog",
            //                 requiresAuth:true 
            //             },
            //         },
            //     ]
            // },
            // {
            //     path:'/Config',
            //     name:'Config',
            //     // component:SOSyncConf,
            //     meta:{ 
            //         title:"基础配置",
            //         icon:"IconRelation",
            //         locale:"menu.config",
            //         requiresAuth:true 
            //     },
            //     children:[
            //         // {
            //         //     path:'/Config/SOSyncConf',
            //         //     name:'SOSyncConf',
            //         //     component: SOSyncConf,
            //         //     meta:{ 
            //         //         title:"SO同步过滤配置",
            //         //         icon:"IconRelation",
            //         //         locale:"menu.soSyncConf",
            //         //         requiresAuth:true 
            //         //     },
            //         // },
            //         // {
            //         //     path:'/Config/OrderSource',
            //         //     name:'OrderSource',
            //         //     component: OrderSource,
            //         //     meta:{ 
            //         //         title:"同步订单来源",
            //         //         icon:"IconRelation",
            //         //         locale:"menu.orderSource",
            //         //         requiresAuth:true 
            //         //     },
            //         // },
            //         {
            //             path:'/Config/EmailReceive',
            //             name:'EmailReceive',
            //             component: EmailReceive,
            //             meta:{ 
            //                 title:"邮件接收配置",
            //                 icon:"IconEmail",
            //                 locale:"menu.emailReceive",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Config/CountryCodeConfig',
            //             name:'CountryCodeConfig',
            //             component: CountryCodeConfig,
            //             meta:{ 
            //                 title:"国家代码配置",
            //                 icon:"IconPublic",
            //                 locale:"menu.countryCodeConfig",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Config/SaleDealerConfig',
            //             name:'SaleDealerConfig',
            //             component: SaleDealerConfig,
            //             meta:{ 
            //                 title:"销售经销商配置",
            //                 icon:"IconUserAdd",
            //                 locale:"menu.saleDealerConfig",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Config/AreaSaleManagerConfig',
            //             name:'AreaSaleManagerConfig',
            //             component: AreaSaleManagerConfig,
            //             meta:{ 
            //                 title:"区域销售经理配置",
            //                 icon:"IconUserAdd",
            //                 locale:"menu.areaSaleManagerConfig",
            //                 requiresAuth:true 
            //             },
            //         },
            //         {
            //             path:'/Config/DeliveryDateRangeConfig',
            //             name:'DeliveryDateRangeConfig',
            //             component: DeliveryDateRangeConfig,
            //             meta:{ 
            //                 title:"经销商发货日期区间配置",
            //                 icon:"IconSun",
            //                 locale:"menu.deliveryDateRangeConfig",
            //                 requiresAuth:true 
            //             },
            //         },
            //     ]
            // },
            {
                path:'/Setting',
                name:'Setting',
                meta:{ 
                    title:"系统设置",
                    icon:"IconSettings",
                    locale:"menu.setting",
                    requiresAuth:true 
                },
                children:[
                    // {
                    //     path:'/Setting/MenuManage',
                    //     name:'MenuManage',
                    //     component:MenuManage,
                    //     meta:{ 
                    //         title:"菜单管理",
                    //         icon:"IconList",
                    //         locale:"menu.menuManage",
                    //         requiresAuth:true 
                    //     },
                    // },
                    {
                        path:'/Setting/Role',
                        name:'Role',
                        component:Role,
                        meta:{ 
                            title:"角色权限管理",
                            icon:"IconLock",
                            locale:"menu.role",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Setting/User',
                        name:'User',
                        component:User,
                        meta:{ 
                            title:"用户角色管理",
                            icon:"IconUserGroup",
                            locale:"menu.user",
                            requiresAuth:true 
                        },
                    },
                    {
                        path:'/Setting/AddEmail',
                        name:'AddEmail',
                        component:AddEmail,
                        meta:{ 
                            title:"邮箱注册管理",
                            icon:"IconEmail",
                            locale:"menu.addEmail",
                            requiresAuth:true 
                        },
                    }
                ]
            },
            
        ],
    },
    {
        path:'/Share',
        name:'DealerForm',
        component:DealerForm,
        meta:{ 
            requiresAuth:true
        }
    },
    {
        path:'/Login',
        name:'Login',
        component:Login,//() => import('@/views/Login.vue'),
    },
    {
        path:'/FeishuLogin',
        name:'FeishuLogin',
        component:FeishuLogin,
    },
    {
        path:'/Register',
        name:'Register',
        component: Register,
    },
    {
        path:'/ForgetPwd',
        name:'ForgetPwd',
        component: ForgetPwd, 
    },
    {
        path:'/ErrorPage',
        name:'404',
        component:ErrorPage,
    },
    {
        path: '/:catchAll(.*)',  // vue3 使用 /:catchAll(.*) 或 /:pathMatch(.*)
        redirect: '/ErrorPage',
    },
    
]

const router = createRouter({
    history:createWebHashHistory(),
    routes,
})


export default router

    